import { Box, Flex, Grid, Image, Text } from '@chakra-ui/react';
import { IdlescapeContainer } from '@idlescape/ui';
import React from 'react';
import { IItem, TPartialItemWithItemID } from '../../../../../game-server/src/modules/items/items.interface';
import { IQuestData } from '../../../../../game-server/src/modules/quest/Quest.interface';
import { questPointIcon } from '../../../helper/itemHelperFunctions';
import { tabs } from '../../../helper/NavigationTabsList';
import { itemList } from '../../../utils/itemList';
import { talentList } from '../../../utils/talentList';
import { Item } from '../Inventory/Item';

export function QuestRewards({ quest }: { quest: IQuestData }) {
	let experienceObj: React.ReactElement[] = [];
	if (quest.questRewards?.experience) {
		experienceObj = Object.entries(quest.questRewards.experience).map(([skill, expReward]) => {
			const skillData = tabs[skill];
			return (
				<Flex key={`exp-reward-${skill}`} margin='1px' padding='1px' flexDirection='column' alignItems='center'>
					<Image width='50px' height='50px' src={skillData.icon} alt={skillData.name} />
					{expReward.toLocaleString('en-us')}
				</Flex>
			);
		});
	}
	let items: React.ReactNode[] = [];
	if (quest.questRewards?.items) {
		items = quest.questRewards.items.map((reward) => {
			if (!quest.questRewards?.items) return null;
			const itemData = itemList[reward.id];
			const newItem: TPartialItemWithItemID<IItem> = {
				itemID: itemData.id,
				augmentations: reward.extra?.augmentations,
				enchantmentID: reward.extra?.enchantmentID,
				enchantmentStrength: reward.extra?.enchantmentStrength,
				name: reward.extra?.name,
				stackSize: reward.amount,
			};
			return <Item item={newItem} key={`reward-item-${reward.id}`} />;
		});
	}
	let talents: React.ReactNode[] = [];
	if (quest.questRewards?.relatedTalent) {
		talents = quest.questRewards.relatedTalent.map((talent) => {
			return (
				<Box key={`talent-reward-${talent}`} margin='1px' padding='1px'>
					{talentList[talent].name}
				</Box>
			);
		});
	}
	if (experienceObj.length === 0 && items.length === 0 && !quest.questRewards?.questPoints && talents.length === 0) {
		return null;
	}
	return (
		<>
			<IdlescapeContainer display='flex' flexDirection='column' textAlign='center' width={'100%'}>
				<Flex justifyContent='center' margin='auto' flexDirection='column'>
					{quest.questRewards?.questPoints && (
						<Text fontSize='xl' marginBottom='1px'>
							{questPointIcon(24)}
							{quest.questRewards.questPoints} Quest Point
							{quest.questRewards.questPoints > 1 && 's'}
						</Text>
					)}

					{talents.length > 0 && (
						<>
							<Text fontSize='xl' marginBottom='1px'>
								Talents:
							</Text>
							<Grid gridTemplateColumns='repeat(auto-fill, minmax(100px, 1fr))' gap='10px' width='100%'>
								{talents.map((talent, index) => (
									<Box key={`${index}-${talent?.toString()}-talent`} padding='2px'>
										{talent}
									</Box>
								))}
							</Grid>
						</>
					)}

					{experienceObj.length > 0 && (
						<>
							<Text fontSize='xl' marginBottom='1px'>
								Experience:
							</Text>
							<Flex gap='10px' justifyContent='center' fontSize='xl' flexWrap='wrap'>
								{experienceObj.map((exp, index) => (
									<Box key={`${index}-${exp?.toString()}-exp`} margin='auto'>
										{exp}
									</Box>
								))}
							</Flex>
						</>
					)}

					{items.length > 0 && (
						<>
							<Text fontSize='xl' marginBottom='1px'>
								Items:
							</Text>
							<Flex width='100%' justifyContent='center' marginBottom='1px' flexWrap='wrap'>
								{items.map((item, index) => (
									<Box key={`${index}-${item?.toString()}-item`} padding='3px'>
										{item}
									</Box>
								))}
							</Flex>
						</>
					)}
				</Flex>
			</IdlescapeContainer>
		</>
	);
}
